export const LOCALIZATION_LANGUAGE_COOKIE_NAME = 'next-serverless-localization-language';
